import {pick} from "lodash";
import moment from "moment";
import {DATE_TIME_FORMAT} from "../../../constants/define"
import {formatInt, removeObjectNullFull} from "../../../utils/functions";

export default class SubscriptionPackageRequest {
    constructor(data = {}) {
        this.setData(data)
    }

    setData(data = {}) {
        this.id = data?.id || "";
        this.state = data?.state || "";
        this.county = data?.county || "";
        this.city = data?.city || "";
        this.metro = data?.metro || "";
        this.period_type = data?.period_type || "";
        this.package_type = data?.package_type || "";
        this.price = data?.price || 0;
        this.status = data?.status || 0;
    }

    exportCreate() {
        return {
            state: this.state,
            county: this.county,
            city: this.city,
            metro: this.metro,
            period_type: this.period_type,
            package_type: this.package_type,
            price: this.price,
            status: this.status,
        }
    }

    exportUpdate() {
        return {
            id: this.id,
            price: this.price,
            status: this.status,
        }
    }

}

export const common = {
    ACTION_FIELD: {
        state: "state",
        county: "county",
        city: "city",
        metro: "metro",
        period_type: "period_type",
        package_type: "package_type",
        price: "price",
        status: "status",
    },
}

export const filtersParams = (filters) => {
    return Object.keys(filters).length > 0 ? removeObjectNullFull({
        valid_time_from: filters?.valid_time_from ? moment(filters?.valid_time_from).format("YYYYMM") : undefined,
        valid_time_to: filters?.valid_time_to ? moment(filters?.valid_time_to).format("YYYYMM") : undefined,
        status: filters?.status === 0 ? 0 : filters?.status || "",
        email: filters?.email || "",
        lead_type: filters?.lead_type || "",
        state: filters?.state || "",
        page_size: filters?.page_size || 10,
        page_index: filters?.page_index || 1,
        order_field: filters?.order_field || "",
        order_value: filters?.order_value || "",
    }) : {}
}

